import * as actions from "./documentPackage.actions";
import * as api from "./documentPackage.api";
import { BASE_PATH_ENTITY, ENTITY, REDUCER_KEY, } from "./documentPackage.constants";
import * as hooks from "./documentPackage.hooks";
import * as promises from "./documentPackage.promises";
import reducer from "./documentPackage.reducer";
import { saga } from "./documentPackage.saga";
import * as selectors from "./documentPackage.selectors";
import * as utils from "./documentPackage.utils";
export * from "./documentPackage.types";
export var REDUCER_KEY_DOCUMENT_PACKAGE = REDUCER_KEY;
export var documentPackageModule = {
    entity: ENTITY,
    reducerKey: REDUCER_KEY,
    basePathEntity: BASE_PATH_ENTITY,
    reducerState: {},
    actions: actions,
    api: api,
    hooks: hooks,
    promises: promises,
    reducer: reducer,
    saga: saga,
    selectors: selectors,
    utils: utils,
};
